import React, { useContext } from 'react';
import {
    Box,
    Button,
    MenuItem,
    TextField,
    Autocomplete,
    Grid
} from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { GaintOFDOrdersContext } from '../../context';
import CommonDateRangePicker from '../common/CommonDateRangePicker';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, onLoadApi, usersList } = useContext(GaintOFDOrdersContext);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters(prev => ({
            ...prev,
            dateRange: { startDate, endDate }
        }));
    };

    const handleSubmit = () => {
        onLoadApi();
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 6, md: 4 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                        >
                            <MenuItem value="awb_no">AWB No.</MenuItem>
                            <MenuItem value="order_no">Order No.</MenuItem>
                        </TextField>

                        <TextField
                            size="small"
                            placeholder="Enter value"
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>
                </Grid>

                <Grid item size={{ xs: 6, md: 4 }}>
                    <Autocomplete
                        options={usersList || []}
                        getOptionLabel={(option) => option.name || option.email || ''}
                        value={usersList.find(item => item.id === filters.user_id) || null}
                        onChange={(e, newValue) => {
                            handleChange('user_id', newValue ? newValue.id : null);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select User"
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 6, md: 4 }}>
                    <Box className="date-picker-wrapper">
                        <CommonDateRangePicker
                            startDate={filters?.dateRange?.startDate}
                            endDate={filters?.dateRange?.endDate}
                            onChange={handleDateRangeChange}
                        />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Box className="filter-actions" sx={{ justifyContent: 'flex-start', mt: 0.5 }}>
                        <Button className="search-btn" variant="contained" color="primary" size="medium" onClick={handleSubmit}>
                            Search
                        </Button>
                        <Button className="reset-btn ml-2" variant="outlined" color="primary" size="medium" onClick={handleReset}>
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
